import { Injectable } from '@angular/core';
import { BaseFirestoreService } from './base-firestore.service';
import { SMSemt } from 'src/app/models/SMSemt';
import { AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class SemtService {

  COLLECTION_NAME = 'Semtler';
  private semt: SMSemt;
  private semtID: string;
  private currentSemtDocRef: AngularFirestoreDocument<any>;
  constructor(private base: BaseFirestoreService) {
  }

  getSemtID() {
    return this.semtID;
  }

  setSemtID(semtID: string) {
    this.semtID = semtID;
  }

  getDocRef(): AngularFirestoreDocument<any> {
    return this.currentSemtDocRef;
  }

  async getSemt() {
    if (!this.semt) {
      this.semt = await this.getSemtFromFirebase();
    }
    return this.semt;
  }

  private async getSemtFromFirebase(): Promise<SMSemt> {
    const docRef = this.base.getDocRef(this.semtID, this.COLLECTION_NAME);
    this.currentSemtDocRef = docRef;
    const doc = await this.base.getDoc(docRef);
    if (doc.exists) {
      const data: SMSemt = Object.assign(doc.data());
      return data;
    }
    return null;
  }
}
